import React from 'react';
import '../../styles/EventSkeleton.css';

interface EventSkeletonProps {
  count?: number;
}

const EventSkeleton: React.FC<EventSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="event-skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="event-skeleton">
          <div className="skeleton-image"></div>
          <div className="skeleton-content">
            <div className="skeleton-title"></div>
            <div className="skeleton-metadata"></div>
            <div className="skeleton-description"></div>
            <div className="skeleton-description-short"></div>
            <div className="skeleton-link"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventSkeleton;
